import { httpService } from "./http.service";

const BASE_URL = "public/forms";

function splitPageName(pageName) {
  const [prefix, slug] = String(pageName || "").split("/");
  if (!prefix || !slug) {
    throw new Error("pageName invalido. Esperado: 'prefix/slug'");
  }
  return { prefix, slug };
}

export const publicFormService = {
  getForm,
  submitResponse,
};

async function getForm(pageName) {
  const { prefix, slug } = splitPageName(pageName);
  return await httpService.get(`${BASE_URL}/${prefix}/${slug}`);
}

async function submitResponse(pageName, payload) {
  const { prefix, slug } = splitPageName(pageName);
  return await httpService.post(`${BASE_URL}/${prefix}/${slug}/responses`, payload);
}
